// hooks/useIframeMode.js
import { useState, useEffect } from "react";
import {
  listenToParentMessages,
  notifyParentLoaded,
} from "../utils/iframeUtils";

export const useIframeMode = () => {
  const [isIframeMode, setIsIframeMode] = useState(false);

  useEffect(() => {
    // Check if we're in an iframe
    const inIframe = window.self !== window.top;

    // Check URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const iframeParam = urlParams.get("iframe") === "true";

    // Check localStorage
    const storedIframeMode = localStorage.getItem("isIframeMode") === "true";

    const iframeMode = inIframe || iframeParam || storedIframeMode;

    setIsIframeMode(iframeMode);

    // Store in localStorage for persistence
    if (iframeMode) {
      localStorage.setItem("isIframeMode", "true");
    }

    // Add iframe-specific styles
    if (iframeMode) {
      document.body.classList.add("iframe-mode");
      // Remove any default margins/padding
      document.body.style.margin = "0";
      document.body.style.padding = "0";
    } else {
      document.body.classList.remove("iframe-mode");
    }
  }, []);

  return isIframeMode;
};

export const useIframeCommunication = () => {
  const [parentMessages, setParentMessages] = useState([]);

  useEffect(() => {
    // Notify parent that Komz has loaded
    notifyParentLoaded();

    // Listen for messages from parent
    const cleanup = listenToParentMessages((message) => {
      setParentMessages((prev) => [...prev, message]);

      // Handle specific message types
      switch (message.type) {
        case "ZIFT_THEME_CHANGE":
          // Handle theme changes from Zift
          if (message.payload.theme) {
            document.documentElement.setAttribute(
              "data-theme",
              message.payload.theme
            );
          }
          break;

        case "ZIFT_RESIZE_IFRAME":
          // Handle iframe resize requests
          if (message.payload.height) {
            document.body.style.height = `${message.payload.height}px`;
          }
          break;

        default:
          console.log("Unhandled message from parent:", message);
      }
    });

    return cleanup;
  }, []);

  return {
    parentMessages,
    // sendMessageToParent,
    // notifyParentUserAuth,
    // notifyParentNavigation,
    // requestParentResize,
  };
};
